import {
  ActionIcon,
  Button,
  MultiSelect,
  Radio,
  Select,
  TextInput,
} from "@mantine/core";
import React, { useEffect, useState } from "react";
import { addUser, getBuData, updateUser } from "../apis/userApis";
import { useDispatch, useSelector } from "react-redux";
import { showNotification } from "@mantine/notifications";
import { departmentDataString } from "./utilities";
import { IconPlus, IconTrash } from "@tabler/icons-react";

const AddUserModal = ({ reload, dataToUpdate, setUserModal }) => {
  const [buData, setBuData] = useState([]);
  useEffect(() => {
    const getBuLabelData = async () => {
      const response = await getBuData();
      setBuData(response.formattedResponse);
    };

    getBuLabelData();
  }, []);
  const [userRoleData, setUserRoleData] = useState(
    dataToUpdate ? dataToUpdate.role : [{ role: "", departments: "" }]
  );
  const [userData, setUserData] = useState(
    dataToUpdate
      ? dataToUpdate
      : {
          name: "",
          email: "",
          enabled: true,
          role: [],
          password: "",
          businessUnits: "",
        }
  );
  console.log(userData);

  const [errors, setErrors] = useState({});
  const rolesRequiringDepartment = [
    "Ob-DeptAdmin",
    "Ob-DeptUser",
    "Ob-CXO",
    "Ob-Finance",
  ];

  function validateUserRoles(userRoleData) {
    const seenRoles = new Set();

    for (const item of userRoleData) {
      const { role, departments } = item;

      // Condition 1: Role should not be empty
      if (!role) {
        alert("please select user role, don't leave it empty");
        return false;
      }

      // Condition 2: Role should be unique
      if (seenRoles.has(role)){
        alert("user role should be unique at each selection");
         return false;}
      seenRoles.add(role);

      // Condition 3: If the role is in rolesRequiringDepartment, departments should not be empty
      if (rolesRequiringDepartment.includes(role) && !departments.trim()) {
        alert("please select department/s for reuired fields");
        return false;
      }
    }

    return true;
  }
  const validateForm = () => {
    const newErrors = {};

    // Check for empty fields
    if (!userData.name) newErrors.name = "User name is required";
    if (!userData.email) newErrors.email = "Email is required";
    if (!userData.id && !userData.password)
      newErrors.password = "Password is required";
    if (!userData.role) newErrors.role = "User role is required";
    if (!userData.businessUnits)
      newErrors.businessUnits = "business unit required";

    if (userData.enabled === undefined) {
      newErrors.enabled = "User permission is required";
    }
    if (userData.role.length > 0) {
    }

    setErrors(newErrors);

    // Return whether the form is valid
    return Object.keys(newErrors).length === 0;
  };

  const addServiceProvider = async (e) => {
    if (validateForm() && validateUserRoles(userRoleData)) {
      e.preventDefault();
      try {
        const userRoles = userRoleData.map((item) => item.role).join(",");
        console.log("userRoles: ", userRoles);
        const response = await addUser({
          name: userData.name,
          email: userData.email,
          role: userRoleData,
          password: userData.password,
          enabled: userData.enabled,
          businessUnits: userData.businessUnits,
          userRoles,
        });
        if (response.success) {
          setUserModal(false);
          reload();
        }
      } catch (error) {
        console.log("errror: ", error);
        alert("error adding user");
      }
    }
  };

  const updateUserDetails = async () => {
    if (validateForm()) {
      const response = await updateUser({ userData });
      if (response.success) {
        showNotification({
          color: "green",
          title: "update user details",
          message: "user details updated",
        });
        setUserModal(false);
        reload();
      }
    }
  };

  console.log("userData: ", userData);
  console.log("userRoleData: ", userRoleData);
  return (
    <>
      <div className="grid grid-cols-2 m-4 gap-4">
        <TextInput
          required
          label="User Name"
          type="text"
          value={userData.name}
          onChange={(e) => setUserData({ ...userData, name: e.target.value })}
          error={errors.name}
        />
        <TextInput
          required
          label="Email"
          type="email"
          value={userData.email}
          onChange={(e) => setUserData({ ...userData, email: e.target.value })}
          error={errors.email}
        />
        {!userData.id && (
          <TextInput
            required
            label="Password"
            type="text"
            value={userData.password}
            onChange={(e) =>
              setUserData({ ...userData, password: e.target.value })
            }
            error={errors.password}
          />
        )}
        <MultiSelect
          label="business unit/s"
          required
          value={userData.businessUnits.split(",")}
          onChange={(value) => {
            setUserData({ ...userData, businessUnits: value.join(",") });
          }}
          data={buData}
          error={errors.businessUnits}
        />
      </div>
      <div>
        {userRoleData.map((role, index) => (
          <div key={index} className="grid grid-cols-2 m-4 gap-4">
            <Select
            searchable
              label="user role"
              value={role.role}
              onChange={(val) =>
                setUserRoleData(
                  userRoleData.map((r, i) =>
                    i === index ? { ...r, role: val } : r
                  )
                )
              }
              data={[
                { label: "admin", value: "Ob-Admin" },
                { label: "CEO", value: "Ob-CEO" },
                // { label: "editor", value: "Ob-Editor" },
                // { label: "agreement-editor", value: "Ag-Editor" },
                { label: "COO", value: "Ob-COO" },
                { label: "CXO", value: "Ob-CXO" },
                { label: "deptadmin", value: "Ob-DeptAdmin" },
                { label: "deptuser", value: "Ob-DeptUser" },
                { label: "auditor", value: "Ob-Auditor" },
              ]}
            />
            <div className="flex">
              <MultiSelect
                className="w-4/5"
                label="Department"
                required={rolesRequiringDepartment.includes(role.role)? true: false}
                value={userRoleData[index].departments.split(",")}
                onChange={(val) =>
                  setUserRoleData(
                    userRoleData.map((r, i) =>
                      i === index ? { ...r, departments: val.join(",") } : r
                    )
                  )
                }
                data={departmentDataString}
                error={errors.departments}
              />
              <div className="w-1/5 flex justify-between mt-6 ml-2">
                <ActionIcon
                  className="ml-3"
                  onClick={() => {
                    const updatedData = userRoleData.filter(
                      (_, i) => i !== index
                    );
                    setUserRoleData(updatedData);
                  }}
                >
                  <IconTrash size={20} color="#1b6f8d" />
                </ActionIcon>
                <ActionIcon
                  onClick={() => {
                    setUserRoleData([
                      ...userRoleData,
                      { role: "", departments: "" },
                    ]);
                  }}
                >
                  <IconPlus size={20} color="#1b6f8d" />
                </ActionIcon>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="m-4">
        <Radio.Group
          label="User Permission"
          spacing="xs"
          withAsterisk
          value={userData.enabled + ""}
          onChange={(val) =>
            setUserData({ ...userData, enabled: val === "true" })
          }
          error={errors.enabled}
        >
          <Radio value="true" label="Enabled" />
          <Radio value="false" label="Disabled" />
        </Radio.Group>

        <div className="flex justify-end">
          {userData.id ? (
            <Button className="mt-4" onClick={(e) => updateUserDetails(e)}>
              Update User
            </Button>
          ) : (
            <Button className="mt-4" onClick={(e) => addServiceProvider(e)}>
              Add User
            </Button>
          )}
        </div>
      </div>
    </>
  );
};

export default AddUserModal;
